<script lang="ts" setup>
  import { Motion } from 'motion-v'
  import { onMounted, ref, useSlots, watchEffect } from 'vue'
  import type { VNode } from 'vue'

  interface Props {
    duration?: number
    delay?: number
    blur?: string
    yOffset?: number
    class?: string
  }

  const props = withDefaults(defineProps<Props>(), {
    duration: 1,
    delay: 2,
    blur: '20px',
    yOffset: 20,
    class: ''
  })

  const container = ref<HTMLElement | null>(null)
  const childElements = ref([])
  const slots = useSlots()

  const children = ref<VNode[]>([])

  onMounted(() => {
    // This will reactively capture all content provided in the default slot
    watchEffect(() => {
      children.value = slots.default ? slots.default() : []
    })
  })
</script>

<template>
  <div ref="container" :class="props.class">
    <Motion
      v-for="(child, index) in children"
      :key="index"
      ref="childElements"
      :while-in-view="{
        opacity: 1,
        filter: 'blur(0px)',
        y: 0
      }"
      :initial="{
        opacity: 0,
        filter: `blur(${props.blur})`,
        y: props.yOffset
      }"
      :transition="{
        duration: props.duration,
        ease: 'easeInOut',
        delay: props.delay * index
      }"
      as="div"
    >
      <component :is="child" />
    </Motion>
  </div>
</template>
